export const isIpad = () =>
    /iPad/i.test(window.navigator.userAgent) ||
    (/Macintosh/i.test(window.navigator.userAgent) && navigator.maxTouchPoints > 1);

export const isIos = () => /iphone|ipod/i.test(window.navigator.userAgent) || isIpad();

export const isMobileOrTabletDevice = () =>
    /Mobi|Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent) ||
    isIpad() ||
    window.matchMedia("(pointer: coarse)").matches;
